import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import styled from 'styled-components';
import Fuse from 'fuse.js';

import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Chip from '@material-ui/core/Chip';

import AddIcon from '@material-ui/icons/Add';

// import Modal from '@material-ui/core/Modal';
import Drawer from '@material-ui/core/Drawer';

import PageHeader from '../../components/PageHeader';
import CreateDocButton from '../../components/CreateDocButton';
import FacilityTableRow from '../../components/FacilityTableRow';

import DetailScreen from './detail';

import { db } from '../../../engine';

import { categoryOptions } from './constants';

import * as Color from '../../../components/Color'

const fuseOptions = {
  shouldSort: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "title.en",
    "title.th",
    "category"
  ]
};

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  flex: 0 1 50%;
  margin-right: 10px;

  box-sizing: border-box;
  padding: 8px 12px;
  display: block;
  border-radius: 100px;
  background: white;
  border: 1px solid #d9d9d9;
  outline: none;
  font-size: 14px;

  &:focus {
    border-color: ${Color.primary};
  }
`;

const BlockContent = styled.div`
  min-height: 100%;
`;

const mapStateToProps = state => {
  const facilityArray = _.map(_.get(state, 'entities.facilities.entities', {}), facility => facility)
  return {
    facilities: facilityArray,
    facilityIds: _.compact(facilityArray),
  }
}
export default connect(mapStateToProps)(class extends React.PureComponent {
  state = {
    searchKeyword: '',
    page: 0,
    rowsPerPage: 10,
  }

  handleSelectFacility = (facilityId) => {
    const { match, history } = this.props;
    history.push(`${match.url}/${facilityId}`);
  }

  handleChangePage = (event, page) => {
    this.setState({ page });
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  }

  handleSave = (facilityId) => {
    const { history } = this.props;
    history.push(`/admin/facilities/${facilityId}`);
    this.handleCloseModal();
  }

  handleCreate = (values) => {
    const { title, category } = values;
    const id = _.kebabCase(`${title}`);

    const data = {
      id,
      title: {
        en: title,
      },
      category: category,
    }

    const docRef = db.collection('facilities').doc(id);
    docRef.set(data).then(() => {
      const { match, history } = this.props;
      history.push(`${match.url}/${id}`);
      this.props.dispatch({
        type: 'ENTITIES/FACILITIES/CREATE',
        id,
        data
      })
    });
  }

  handleDelete = (docRefId) => {
    this.props.dispatch({
      type: 'ENTITIES/FACILITIES/DELETE',
      id: docRefId,
    })
  }

  handleUpdate = (docRefId, fieldValues) => {
    const { facilities } = this.props
    console.log('handleUpdate​', { docRefId, fieldValues })
    const facility = _.find(facilities, facility => facility.id === docRefId)
    /*
      // fieldValues
      category: "office"
      lat: 13.747512
      lon: 100.534616
      title: "Pond's Home"
      titleTH: "บ้านปอนด์"
    */

    this.props.dispatch({
      type: 'ENTITIES/FACILITIES/UPDATE',
      id: docRefId,
      data: {
        ...facilities,
        category: _.get(fieldValues, 'category', _.get(facility, 'title.th', '')),
        location: {
          lat: _.get(fieldValues, 'lat', _.get(facility, 'location.lat', 0)),
          lon: _.get(fieldValues, 'lon', _.get(facility, 'location.lon', 0)),
        },
        title: {
          th: _.get(fieldValues, 'titleTH', _.get(facility, 'title.th', '')),
          en: _.get(fieldValues, 'title', _.get(facility, 'title.en', '')),
        },
      }
    })
  }

  handleSearchInputChange = (e) => {
    this.setState({
      searchKeyword: e.target.value
    })
  }

  filterFacilities = () => {
    const { searchKeyword } = this.state
    const { facilities } = this.props
    if (_.isEmpty(searchKeyword)) return facilities
    const fuse = new Fuse(facilities, fuseOptions);
    return _.sortBy(fuse.search(searchKeyword), item => item.id);
  }

  render() {
    const { match, history, facilityIds } = this.props;
    const listScreenUrl = match.url;

    const { rowsPerPage, page } = this.state;

    const filterFacilities = this.filterFacilities()
    const visibleIds = _.map(filterFacilities, facility => facility.id).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    // const { facilities } = this.state;
    return (
      <BlockContent>
        <Helmet>
          <title>Facilities | MI Treasure</title>
        </Helmet>
        <PageHeader
          title="Facilities"
          renderActionButtons={() =>
            <CreateDocButton
              label="Facility"
              fields={[
                { type: 'TextField', name: 'title', label: 'Title', required: true },
                { type: 'Dropdown', name: 'category', label: 'Category', options: categoryOptions },
              ]}
              renderButton={() => <Button variant="extendedFab" color="primary"><AddIcon /> Add Facility</Button>}
              onCreate={this.handleCreate}
            />
          }
        />
        <SearchContainer>
          <Input
            onChange={this.handleSearchInputChange}
            placeholder="Search by facility keyword..."
          />
          <Chip
            color="primary"
            label={`found ${_.size(filterFacilities)} facilities`}
          />
        </SearchContainer>
        <Table>
          <TableHead>
            <TableRow>
              {/* <TableCell>ID</TableCell> */}
              <TableCell>Title</TableCell>
              <TableCell>TYPE</TableCell>
              <TableCell>LAT</TableCell>
              <TableCell>LON</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_.map(visibleIds, facilityId =>
              <FacilityTableRow
                key={facilityId}
                id={facilityId}
                onClick={e => this.handleSelectFacility(facilityId)}
              />
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={facilityIds.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
        {/* <Modal
          open={this.state.openModel}
          onClose={this.handleCloseModal}
        >
        </Modal> */}
        <Route
          path={`${match.url}/:facilityId`}
          children={({ match, ...rest }) => {
            const facilityId = _.get(match, 'params.facilityId');
            const docRef = !_.isEmpty(facilityId) ? db.collection('facilities').doc(facilityId) : null;
            const open = facilityId !== undefined;
            return (
              <Drawer anchor="right" open={open} onClose={() => history.push(listScreenUrl)}>
                <DetailScreen
                  width="700px"
                  {...rest}
                  facilityId={facilityId}
                  docRef={docRef}
                  onSave={this.handleUpdate}
                  onClose={() => {
                    history.push(listScreenUrl);
                  }}
                  onDelete={this.handleDelete}
                />
              </Drawer>
            );
          }}
        />
      </BlockContent>
    );
  }
});



// WEBPACK FOOTER //
// ./src/admin/screens/Facility/index.js